import { WeatherTrafficCamContainerView } from './weatherTrafficCamContainerView';

const props = [
    'cameraPageViewType'
];

export const WeatherTrafficCamContainerViewDirective = reactDirective => reactDirective(WeatherTrafficCamContainerView, props);
WeatherTrafficCamContainerViewDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('weatherTrafficCamContainerView', WeatherTrafficCamContainerViewDirective);
